import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withFieldProps } from 'hooks/useFieldProps';
import { withStyles } from 'theme/withStyles';
import FlyupLabel from 'common/FlyupLabel';
import Spinner from 'common/Spinner';
import ErrorMsg from 'common/ErrorMsg';
import Help from 'common/Help';
import Tooltip from 'common/Tooltip';

import rootStyles from './styles/root';
import inputStyles from './styles/input';

const styles = ({ forms, palette, spacing, typography }) => ({
  input: inputStyles({ forms, palette, typography }),
  root: rootStyles({ spacing }),
});

const Decimal = ({
  classes,
  error,
  fieldDomId,
  help,
  loading,
  name,
  onBlur,
  onChange,
  onFocus,
  onPaste,
  placeholder,
  readOnly,
  required,
  tooltip,
  type,
  validate,
  value,
}) => (
  <>
    <div className={classnames('form-group', { error }, classes.root)}>
      <Spinner loading={loading} />
      <FlyupLabel
        fieldName={name}
        error={error}
        value={value}
        htmlFor={fieldDomId}
        required={required}
        tooltip={tooltip}
      />
      <input
        aria-describedby={
          classnames({
            [`help-${name}`]: help,
            [`error-${name}`]: error,
          }) || undefined
        }
        aria-invalid={error}
        type={type}
        inputMode="decimal"
        className={classnames('form-control', classes.input)}
        name={name}
        id={fieldDomId}
        value={value}
        placeholder={placeholder}
        readOnly={readOnly}
        required={required}
        onChange={(e) => {
          onChange(name, e.target.value);
          if (error) {
            validate(false);
          }
        }}
        onFocus={onFocus}
        onPaste={onPaste}
        onBlur={() => {
          onBlur();
          validate();
        }}
      />
      <Tooltip tooltip={tooltip} labeledBy={`label-${fieldDomId}`} />
      <Help help={help} id={`help-${name}`} />
    </div>
    <ErrorMsg name={name} />
  </>
);

Decimal.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  error: PropTypes.bool.isRequired,
  fieldDomId: PropTypes.string.isRequired,
  help: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired,
  required: PropTypes.bool.isRequired,
  tooltip: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  validate: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

const DecimalStyled = withStyles(styles)(Decimal);

const mapStateToProps = ({ fields }, { name }) => {
  const field = fields[name];
  return {
    type: field.mobileInputType || 'number',
  };
};

export default withFieldProps(mapStateToProps)(DecimalStyled);
